
export const HOOKS_DEEP_DIVE_PRACTICE = {
  task: "Create a custom hook for form validation with real-time feedback",
  starter: `function useFormValidation(initialValues, validationRules) {
  // TODO: Implement form validation hook
  return { values: {}, errors: {}, isValid: false };
}`,
  solution: `function useFormValidation(initialValues, validationRules) {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const validateField = useCallback((name, value) => {
    const rules = validationRules[name];
    if (!rules) return '';

    for (const rule of rules) {
      const result = rule(value);
      if (result !== true) return result;
    }
    return '';
  }, [validationRules]);

  const handleChange = useCallback((name, value) => {
    setValues(prev => ({ ...prev, [name]: value }));
    
    if (touched[name]) {
      const error = validateField(name, value);
      setErrors(prev => ({ ...prev, [name]: error }));
    }
  }, [touched, validateField]);

  const handleBlur = useCallback((name) => {
    setTouched(prev => ({ ...prev, [name]: true }));
    const error = validateField(name, values[name]);
    setErrors(prev => ({ ...prev, [name]: error }));
  }, [values, validateField]);

  const isValid = useMemo(() => {
    return Object.values(errors).every(error => !error);
  }, [errors]);

  return {
    values,
    errors,
    touched,
    isValid,
    handleChange,
    handleBlur
  };
}`,
  hints: [
    "Use useState for form state management",
    "Implement real-time validation with useCallback",
    "Track touched fields separately",
    "Memoize expensive validations"
  ]
};
